import { useEffect } from 'react'
import useReport from './useReport'
import useUpdateReportDoc from './useUpdateReportDoc'
import { checkAllStepsCompleted } from '../utils/reportCompletion'

/**
 * Custom hook that automatically checks if all 13 steps are completed
 * and sets the allStepsCompleted flag in Firestore when they are
 */
export function useReportCompletionCheck(month: string) {
  const report = useReport(month)
  const updateReport = useUpdateReportDoc()

  useEffect(() => {
    // Only proceed if we have a report
    if (!report) {
      return
    }

    // If already marked as complete, don't check again to prevent redundant writes
    if (report.allStepsCompleted === true) {
      return
    }

    // Check if all steps are now complete
    const allComplete = checkAllStepsCompleted(report)

    // If all steps are complete, update the report
    if (allComplete) {
      updateReport({
        allStepsCompleted: true,
      }).catch((error) => {
        console.error('Failed to update allStepsCompleted flag:', error)
      })
    }
  }, [report, updateReport, month])
}

export default useReportCompletionCheck
